import $ from 'jquery';
import { Loader } from '@googlemaps/js-api-loader';

const $maps = $('.js-map');

const styles = [
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e9e9e9',
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f5f5',
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 29,
      },
      {
        weight: 0.2,
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 18,
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f5f5',
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [
      {
        color: '#dedede',
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#ffffff',
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        saturation: 36,
      },
      {
        color: '#333333',
      },
      {
        lightness: 40,
      },
    ],
  },
  {
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f2f2f2',
      },
      {
        lightness: 19,
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#fefefe',
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#fefefe',
      },
      {
        lightness: 17,
      },
      {
        weight: 1.2,
      },
    ],
  },
];

const icon = `${WORDPRESS.TEMPLATE_DIRECTORY_URI}/assets/img/hayherlee-marker.png`;

if ($maps.length >= 1) {
  const loader = new Loader({
    apiKey: WORDPRESS.GOOGLE_API_KEY,
    version: 'weekly',
    libraries: ['maps', 'marker'],
  });

  loader.load().then(async () => {
    const { Map } = await google.maps.importLibrary('maps');
    const { Marker } = await google.maps.importLibrary('marker');
    $maps.each(function (index, element) {
      initializeMap($(element), Map, Marker);
    });
  });
}

function initializeMap($map, Map, Marker) {
  const lat = Number($map.attr('data-lat'));
  const lng = Number($map.attr('data-lng'));
  const zoom = Number($map.attr('data-zoom'));
  const center = { lat, lng };
  const map = new Map($map[0], { center, zoom, styles });
  const marker = new Marker({ position: center, map, icon });
}

/*

function getMapZoom($map) {
  if ($map.attr('data-zoom')) {
    return Number($map.attr('data-zoom'));
  }
  return 14;
}

function getMapLat($map) {
  if ($map.attr('data-lat')) {
    return Number($map.attr('data-lat'));
  }
  return 51.048615;
}

function getMapLng($map) {
  if ($map.attr('data-lng')) {
    return Number($map.attr('data-lng'));
  }
  return -114.070847;
}

function getMarkerIcon() {
  const width = 55;
  const height = 72;
  return {
    path: 'M55 27.5c.18 21.95-27.41 45.86-27.41 45.86S0 49.45 0 27.5C0 12.31 12.31 0 27.5 0S54.87 12.31 55 27.5z',
    fillColor: '#f34b3d',
    fillOpacity: 1,
    strokeWeight: 0,
    anchor: new google.maps.Point(width / 2, height),
  };
}

function initializeMap($map) {
  const $markers = $map.find('.js-marker');
  const infoWindow = new google.maps.InfoWindow();
  const bounds = new google.maps.LatLngBounds();

  const map = new google.maps.Map($map[0], {
    center: { lat: getMapLat($map), lng: getMapLng($map) },
    mapId: 'aa88be42785da5f9',
    clickableIcons: false,
    disableDefaultUI: true,
    streetViewControl: false,
    zoom: getMapZoom($map),
    zoomControl: true,
  });

  map.addListener('click', () => handleMapClick());
  map.addListener('zoom_changed', () => handleMapZoomChanged());

  const markers = $markers
    .map((index, element) => {
      const $marker = $(element);
      const marker = new google.maps.Marker({
        position: {
          lat: Number($marker.data('lat')),
          lng: Number($marker.data('lng')),
        },
        icon: getMarkerIcon(),
        map,
      });
      if ($marker.html()) {
        marker.addListener('click', () => {
          infoWindow.setContent($marker.html());
          infoWindow.open(map, marker);
        });
      }
      return marker;
    })
    .get();

  if (markers.length >= 2) {
    for (const marker of markers) {
      bounds.extend(marker.position);
    }
    map.fitBounds(bounds);
  }

  if (markers.length === 1) {
    map.setCenter(markers[0].getPosition());
  }

  function handleMapClick() {
    infoWindow.close();
  }

  function handleMapZoomChanged() {
    infoWindow.close();
  }
}

*/
